import { Command, HttpMethod } from "~/extensions/api";
import { encryptData } from "~/extensions/utils/EncryptData";
import { commonStore } from "~/store/CommonStore";
export class ChangePassword extends Command {
    constructor() {
        super(HttpMethod.Post, "auth/password/change");
    }
    static async Create(password) {
        let command = new ChangePassword();
        command.current = await encryptData(commonStore.publicKey, password.current);
        command.new = await encryptData(commonStore.publicKey, password.new);
        command.confirm = await encryptData(commonStore.publicKey, password.confirm);
        return command;
    }
    current = "";
    new = "";
    confirm = "";
}
